<button type="button" mat-button class="view-selector-mainbutton" [matMenuTriggerFor]="selectorMenu" [disabled]="disabled()">
  <mat-icon>bookmarks</mat-icon>
</button>

<mat-menu #selectorMenu="matMenu" class="view-selector-buttons" (closed)="onClose()">
  @for (viewTab of viewTabs(); track viewTab.viewId) {
    <button
      type="button"
      mat-menu-item
      [disabled]="visibleViewTabsCount <= 1 && viewTab.isVisible"
      (click)="onViewTabClick($event, viewTab)">
      @if (viewTab.isVisible) {
        <mat-icon>star</mat-icon>
      } @else {
        <mat-icon>star_border</mat-icon>
      }
      {{ viewTab.label }}
    </button>
  }
</mat-menu>
